import { useTheme } from '@emotion/react';
import React from 'react';
import assets25trayecto from '../../../innerAsstes/Seccion trayecto/Recurso 25trayecto.png';
import { useAppContext } from '../../../App';

export const SlideCareer = () => {
  const theme = useTheme();
  const {isMobile} = useAppContext();
  
  const style = styles(theme, isMobile);
  return (
    <div style={style.textAndImgContainer} className="sansation-bold">
      <div style={style.textContainer}>
        <p style={{ ...style.whiteText, ...style.fontSizeStyle }}>
          PROYECTÁ TU TRAYECTO PROFESIONAL
        </p>
        <p style={{ ...style.blueText, ...style.fontSizeStyle }}>
          EN GESTAR EDUCATIVA
        </p>
        <p style={style.whiteText2}>
          Nuestros cursos están diseñados para que COMPLEMENTADOS ENTRE SÍ,
          alcances Diplomados y Secretariados.
        </p>
      </div>
      <img style={style.imageContainer} src={assets25trayecto} alt="" />
    </div>
  );
};
  
const styles = (theme, isMobile) => ({
  textAndImgContainer: {
    display: "flex",
    flexDirection: isMobile? "column-reverse":"row",
    justifyContent: "space-around",
    alignContent: "center",
    width: '100%',
  },
  textContainer: {
    padding: '5vh',
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
    justifyContent:"center",
  },
  imageContainer: {
    width: isMobile ? '100%' : 'auto', // Cambia aquí
    height: isMobile ? 'auto' : '60vh', // Cambia aquí
    maxHeight: isMobile ? '40vh' : '60vh', // Limita la altura en móvil
    display: 'flex',
    justifySelf: "center",
    objectFit: 'contain',
  },
  whiteText: {
    lineHeight: 1,
    lineSpacing: 1,
    color: theme.color.text.primary,
  },
  whiteText2: {
    lineHeight: 1.2,
    fontSize: isMobile? "1rem" : '2rem',
    color: theme.color.text.primary,
  },
  blueText: {
    lineHeight: 1,
    marginBottom: '1rem',
    color: theme.color.text.secondary,
  },
  fontSizeStyle: {
    fontSize: isMobile? "1rem" : "1rem",
  },
});
